export const EmployeesIcon = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_446_19074)">
        <path
          d="M5 6C6.6545 6 8 4.6545 8 3C8 1.3455 6.6545 0 5 0C3.3455 0 2 1.3455 2 3C2 4.6545 3.3455 6 5 6ZM5 1C6.103 1 7 1.897 7 3C7 4.103 6.103 5 5 5C3.897 5 3 4.103 3 3C3 1.897 3.897 1 5 1ZM3 7H5.88C5.684 7.2925 5.5545 7.633 5.514 8H3C2.173 8 1.5 8.673 1.5 9.5V12H0.5V9.5C0.5 8.1215 1.6215 7 3 7ZM11.25 7H11V6.75C11 6.3365 10.6635 6 10.25 6H8.75C8.3365 6 8 6.3365 8 6.75V7H7.75C7.061 7 6.5 7.561 6.5 8.25V12H12.5V8.25C12.5 7.561 11.939 7 11.25 7ZM7.75 8H11.25C11.388 8 11.5 8.112 11.5 8.25V9H7.5V8.25C7.5 8.112 7.612 8 7.75 8ZM7.5 11V10H9V10.5H10V10H11.5V11H7.5Z"
          fill="#41395C"
        />
      </g>
      <defs>
        <clipPath id="clip0_446_19074">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
